import { getBlockPluginsByCategory } from '../core/BlockPluginRegistry';
import { useEditorAdapter } from '../core/EditorAdapterContext';
import InsertModeDropdown, {
    type InsertAction
} from '../plugins/InsertModeDropdown';

interface InsertComponentDropdownProps {
    /** Extra actions not driven by the registry (e.g., BPMN generator). */
    extraActions?: InsertAction[];
    disabled?: boolean;
}

const InsertComponentDropdown = ({
    extraActions = [],
    disabled
}: InsertComponentDropdownProps) => {
    const adapter = useEditorAdapter();

    const pluginActions: InsertAction[] = getBlockPluginsByCategory('component')
        .filter((p) => p.toolbarInsert)
        .map((plugin) => ({
            id: plugin.name,
            icon: plugin.toolbarInsert!.icon,
            title: plugin.toolbarInsert!.title,
            description: plugin.toolbarInsert!.description,
            callback: () => {
                if (plugin.toolbarInsert!.customInsert) {
                    plugin.toolbarInsert!.customInsert(adapter);
                } else {
                    const defaultData: unknown =
                        typeof plugin.defaultData === 'function'
                            ? (plugin.defaultData as () => unknown)()
                            : plugin.defaultData;
                    adapter.insertBlock(plugin.name, defaultData);
                }
            }
        }));

    return <InsertModeDropdown actions={[...pluginActions, ...extraActions]} disabled={disabled} />;
};

export default InsertComponentDropdown;
